import { render, staticRenderFns } from "./OrderGoods.vue?vue&type=template&id=26a7eaf4&scoped=true"
import script from "./OrderGoods.vue?vue&type=script&lang=js"
export * from "./OrderGoods.vue?vue&type=script&lang=js"
import style0 from "./OrderGoods.vue?vue&type=style&index=0&id=26a7eaf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a7eaf4",
  null
  
)

export default component.exports